import React from "react";
import { Col, Row, Container, Form } from "react-bootstrap";
import PropTypes from 'prop-types';
import { makeStyles } from "@material-ui/core/styles";
import SvgIcon from '@material-ui/core/SvgIcon';
import AffordableIcon from '../../../../icons/affordable.svg';
import FastIcon from '../../../../icons/fast.svg';
import EasyIcon from '../../../../icons/easy.svg';
import BackNext from "../../Common/SubComponents/BackNext";

const useStyles = makeStyles(theme => ({
    textcolor: {
        color: theme.palette.primary.main,
    }
}));

const categories = [
    {
        icon: EasyIcon,
        title: "Easy",
        description: "No Medical Exam",
    },
    {
        icon: AffordableIcon,
        title: "Affordable",
        description: "Competitive Prices",
    },
    {
        icon: FastIcon,
        title: "Fast",
        description: "Apply in 15 minutes",
    },
]

export default function GettingStarted(props) {
    const classes = useStyles()
    return (
        <Container className="mt-5 pb-3">
            <Form onSubmit={props.onNext}>
                <Row className="justify-content-center">
                    <Col lg={10} className="getting-started">
                        <Row className="heroImage">
                        </Row>
                        <Row className="text-center category">
                            {categories.map((item, index) =>
                                <Col className="category-item" key={index}>
                                    <div className="category-icon">
                                        <SvgIcon component={item.icon} color="primary" />
                                    </div>
                                    <div className="category-text">
                                        <h6 className="mb-0 mt-1 category-title">{item.title}</h6>
                                        <div className="category-desc">{item.description}</div>
                                    </div>
                                </Col>
                            )}
                        </Row>
                        <Row className="text-center mt-3">
                            <Col>
                                <h3>Relax. We’ll help cover you.</h3>
                                <div className="category-desc mb-4">Next steps to finding the rate that works for you, and applying online.</div>
                            </Col>
                        </Row>
                        <Row className="justify-content-center">
                            <Col className="col-auto steps-section">
                                <div className="steps-container">
                                    <div className="step">
                                        <div><span className={`step-number ${classes.textcolor}`}>1</span></div>
                                        <div className="step-text">Provide basic personal information</div>
                                    </div>
                                    <div className="step">
                                        <div><span className={`step-number ${classes.textcolor}`}>2</span></div>
                                        <div className="step-text">Review your personalized quote with no obligation</div>
                                    </div>
                                    <div className="step">
                                        <div><span className={`step-number ${classes.textcolor}`}>3</span></div>
                                        <div className="step-text">Accept quote and submit your application</div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row className="justify-content-center pb-1 mt-3">
                            <span><h6 className={`mb-0 quote-text ${classes.textcolor}`}>Ready? Let's get started </h6></span>
                        </Row>
                        <div className='backnext-wrapper'>
                            <BackNext onBack={props.onBack} isAflac={true} continueLabel={{text: "Next"}} />
                        </div>
                    </Col>
                </Row>
            </Form>
        </Container>
    )
}

GettingStarted.propTypes = {
    onNext: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
}


// WEBPACK FOOTER //
// ./src/components/Quoters/Aflac/steps/GettingStarted.js